import {loadScript} from "../module/load-script.function";
import {InViewportClass} from "../in-viewport/in-viewport.class";

export default class MapClass {
  private readonly container = document.querySelector('.js-map');
  private readonly mapStyle = [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}];
  private readonly apiKey = 'AIzaSyD5eLT8eOFph_v0ZI9GT8k3BGAav7lcyBQ';
  private alreadyLoaded = false;
  constructor() {
  }

  viewportListener(inViewport: InViewportClass): void {
    inViewport.addElement('.js-map', () => this.load());
  }

  load(): void {
    if (this.alreadyLoaded) {
      return;
    }

    this.alreadyLoaded = true;
    loadScript(`https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&language=${document.documentElement.lang}&sensor=false`, () => {
      const mapCoord = {
        'lat': this.container.getAttribute('data-lat'),
        'lng': this.container.getAttribute('data-lng')
      };

      const mapLoc = new google.maps.LatLng(mapCoord.lat, mapCoord.lng);
      const mapOptions = {
        zoom: 14,
        center: mapLoc,
        disableDefaultUI: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: this.mapStyle
      };

      const map = new google.maps.Map(this.container, mapOptions);

      new google.maps.Marker({
        position: mapLoc,
        map: map,
        icon: '/img/pin.png',
      });
    })
  }
}
